import {
  START_PROCESS_TRANSACTION_MODAL_OPEN,
  START_PROCESS_TRANSACTION_MODAL_CLOSE,
  START_PROCESS_TRANSACTION_MODAL_SUBMITTED,
  START_PROCESS_TRANSACTION_MODAL_VALIDATE,
  START_PROCESS_TRANSACTION_MODAL_CANCEL,
  START_PROCESS_TRANSACTION_MODAL_RESET,
  START_PROCESS_TRANSACTION_FAILURE,
  START_PROCESS_TRANSACTION_SUCCESS,
} from '../actions/start_process_transaction'

export function processTransactionStartModalDialog(
  state = {
    isModalDialogOpen: false,
    newData: null,
    isSubmitted: false,
    isValidated: true,
    isSuccessSubmit: null,
    content: null,
    error: null,
  },
  action
) {
  switch (action.type) {
    case START_PROCESS_TRANSACTION_MODAL_OPEN:
      return {
        ...state,
        isModalDialogOpen: true,
        content: action.content,
      }
    case START_PROCESS_TRANSACTION_MODAL_CLOSE:
      return {
        ...state,
        isModalDialogOpen: false,
        isSubmitted: false,
        isValidated: true,
        isSuccessSubmit: null,
        content: null,
        error: null,
        newData: null,
      }
    case START_PROCESS_TRANSACTION_MODAL_CANCEL:
      return {
        ...state,
        isModalDialogOpen: false,
        isSubmitted: false,
        isValidated: true,
        newData: null,
        error: null,
        content: null,
        isSuccessSubmit: null,
      }
    case START_PROCESS_TRANSACTION_MODAL_SUBMITTED:
      return {
        ...state,
        isSubmitted: true,
        newData: action.newData,
      }
    case START_PROCESS_TRANSACTION_MODAL_VALIDATE:
      return {
        ...state,
        isValidated: action.isValidated,
      }
    case START_PROCESS_TRANSACTION_MODAL_RESET:
      return {
        ...state,
        newData: null,
        isSubmitted: false,
        isSuccessSubmit: null,
        error: null,
        content: null,
      }
    case START_PROCESS_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        isSuccessSubmit: false,
      }
    case START_PROCESS_TRANSACTION_SUCCESS:
      return {
        ...state,
        isSuccessSubmit: true,
        error: null,
      }
    default:
      return state
  }
}
